import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[100vh] min-h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://maxsails.ca/images/home_image.jpg"
        alt="Sailing boats on the water - MAX Sails Canada"
        className="absolute inset-0 w-full h-full object-cover object-center"
        onError={(e) => {
          (e.target as HTMLImageElement).src =
            'https://public.readdy.ai/ai/img_res/ec5bfb7e08cc8c04a5ffdc029888a086.jpg';
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />

      <div className="relative z-10 w-full text-center px-6">
        <p className="text-red-400 text-sm uppercase tracking-[0.3em] font-medium mb-4">
          {t('hero_tagline')}
        </p>
        <h1 className="text-white font-black text-5xl md:text-7xl leading-tight mb-6" style={{ fontFamily: "'Montserrat', sans-serif" }}>
          {t('hero_title')}
        </h1>
        <p className="text-white/80 text-lg md:text-xl max-w-xl mx-auto mb-10 leading-relaxed">
          {t('hero_subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact"
            className="px-8 py-3 rounded-full bg-red-600 text-white font-semibold text-sm hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            {t('hero_cta_quote')}
          </Link>
          <Link
            to="/products"
            className="px-8 py-3 rounded-full border border-white/60 text-white font-semibold text-sm hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
          >
            {t('hero_cta_products')}
          </Link>
        </div>
      </div>
    </section>
  );
}
